import { CaseCategory, CaseListItem } from '~/entities/case'
export type Grouped<T> = T & { group: string }

// Backbone of the triage picker: the generated snake_case case list item plus a
// derived display title.
export type CaseWithTitle = CaseListItem & { title: string }
export type CaseOrCategory = CaseWithTitle | CaseCategory

export type GroupedCaseOrCategory = Grouped<CaseOrCategory>

export function isCase(caseOrCategory: CaseOrCategory): caseOrCategory is CaseWithTitle {
  return (caseOrCategory as CaseWithTitle).category !== undefined
}
